<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">充电费率管理</h3>
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="$router.push({name: 'billRateEdit',params:{id:'add'}})"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <div class="dataTables_length">
              <label>
                <select class="select-option form-control" v-model="pageSize">
                  <option v-for="(item, i) in selects" :key="i">{{ item }}</option>
                </select>
              </label>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtnCharge"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="table-responsive">
            <section ref="print">
              <table
                class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
              >
                <thead>
                  <tr>
                    <th
                      class="text-center sorting"
                      style="width: 60px; min-width:60px"
                      @click="getList('ID',$event)"
                    >#</th>
                    <th
                      class="text-left sorting"
                      style="min-width:200px;"
                      @click="getList('SITE_NAME',$event)"
                    >站点名称</th>
                    <th
                      class="text-left sorting"
                      style="min-width:200px;"
                      @click="getList('CELL_NAME',$event)"
                    >所属小区</th>
                    <th
                      class="text-left d-md-table-cell sorting"
                      style="min-width:100px;"
                      @click="getList('RATE_TYPE',$event)"
                    >费率类型</th>
                    <!-- <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:160px;"
                        @click="getList('RATE_DATA',$event)"
                    >设备类型</th>-->
                    <th
                      class="text-left d-xl-table-cell sorting"
                      style="min-width:160px;"
                      @click="getList('FREE_DURATION',$event)"
                    >不计费时长(分钟)</th>

                    <th
                      class="text-left d-xl-table-cell sorting"
                      style="min-width:100px;"
                      @click="getList('RATE_TYPE',$event)"
                    >费率档数</th>
                    <!-- <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:400px;"
                        @click="getList('RATE_DATA',$event)"
                    >费率详情</th>-->
                    <!-- <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:150px;"
                        @click="getList('CREATE_TIME',$event)"
                    >创建时间</th>-->
                    <th
                      class="text-left d-xl-table-cell sorting"
                      style="min-width:130px;width:130px;"
                      @click="getList('TYPE',$event)"
                    >仅白名单用户</th>
                    <th
                      class="text-center no-print"
                      style="width: 100px; min-width:100px"
                      v-if="editBtn"
                    >操作</th>
                  </tr>
                </thead>
                <tbody v-if="agents.length">
                  <tr v-for="(agent, i) in agents" :key="i">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td class="text-left">{{ agent.SITE_NAME }}</td>
                    <td class="text-left">{{ agent.CELL_NAME }}</td>
                    <td class="text-left d-md-table-cell">{{ showType(agent.RATE_TYPE) }}</td>
                    <!-- <td class="text-left d-md-table-cell">{{showDeviceType(agent.DeviceType)}}</td> -->
                    <td class="text-left d-xl-table-cell">{{agent.FREE_DURATION}}</td>
                    <td class="text-left d-md-table-cell">
                      <a href="javascrpit:void(0)" @click="create('',agent.ID)">{{ agent.RATE_NUM }}</a>
                    </td>
                    <!-- <td class="text-left text-left d-xl-table-cell">
                        <div v-for="(p, index) in JSON.parse(agent.RATE_DATA)" :key="index">
                          <span v-if="p.PowerType">{{ p.PowerType + '档功率'}}：</span>
                          <div
                            v-show="agent.RATE_TYPE == 'BillingNormal'"
                            style="display: inline-block;"
                          >
                            <span>首{{ p.FirstStep?p.FirstStep+ '分钟':"" }}</span>
                            <span>{{ p.FirstStepRate }}元、</span>
                            <span
                              v-if="p.Step|| (p.DataList && p.DataList[0].Step)"
                            >后{{ p.Step || p.DataList[0].Step }}分钟</span>
                            <span
                              v-if="p.StepRate || (p.DataList && p.DataList[0].Rate)"
                            >{{ p.StepRate || p.DataList[0].Rate }}元</span>
                          </div>

                          <span
                            v-show="agent.RATE_TYPE == 'BillingSection' && (p.StepRate || (p.DataList && p.DataList[0].Rate))"
                            v-for="(item, index) in p.DataList"
                            :key="index"
                          >{{item.Step}}分钟{{ item.Rate }}元{{index==(p.DataList.length-1)?'':'、'}}</span>
                        </div>
                    </td>-->
                    <!-- <td class="text-left d-md-table-cell">{{ agent.CREATE_TIME }}</td> -->
                    <td class="text-center d-md-table-cell">
                      <!-- <div class="custom-control custom-switch custom-control-primary">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          name="example-sw-primary2"
                          :checked="agent.TYPE == 1 ? true :  false"
                          disabled
                        />
                        <label
                          class="custom-control-label"
                          :for="'dexample-sw-custom-success-state' + agent.ROWNUM"
                        ></label>
                      </div>-->
                      <i
                        class="fa"
                        :class="agent.TYPE == 1 ? 'fa-check-circle text-success' :  'fa-minus-circle text-gray'"
                      ></i>
                    </td>

                    <td class="text-center no-print" v-if="editBtn">
                      <div class="btn-group">
                        <button
                          type="button"
                          class="btn btn-primary js-tooltip-enabled"
                          title="查看"
                          data-original-title="Edit"
                          data-toggle="modal"
                          @click="$router.push({name: 'fieldChargeRateEdit',params:{id:agent.ID,val:key,type:'billRateEdit' }})"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="9">查无数据</td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
          <div class="dataTables_info" role="status" aria-live="polite">
            页数
            <strong>{{ page }}</strong> /
            <strong>{{ totalPage }}</strong>
          </div>
        </div>
        <div class="col-sm-12 col-md-7 text-center text-md-right">
          <div class="dataTables_paginate paging_full_numbers">
            <el-pagination
              v-if="agents && agents.length"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="pageSize"
              :small="isMobile"
              :pager-count="pagerCount"
              :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
              :total="total"
              background
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <!-- 新增、编辑 -->
    <div
      class="modal fade"
      id="modal-default-normal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{edit=='add'?'新增充电费率':'充电费率详情'}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group" v-show="edit=='add'">
                <label class="col-sm-12 control-label">
                  所在区域
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    :disabled="edit!='add'"
                    class="form-control col-sm-4 form-group-b"
                    style="float:left"
                    @change="provinceSel()"
                    v-model="pro"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in provinceList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    :disabled="edit!='add'"
                    class="form-control col-sm-4 form-group-b"
                    style="float:left"
                    @change="citySel()"
                    v-model="city"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cityList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    :disabled="edit!='add'"
                    class="form-control col-sm-4 form-group-b"
                    @change="disSel()"
                    v-model="dis"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in districtList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    v-show="edit=='add'"
                    :disabled="edit!='add'"
                    class="form-control col-sm-12"
                    v-model="form.cellId"
                    @change="cellSel()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>
                  <input
                    v-show="edit=='edit'"
                    disabled
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="cellName"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  费率类型
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.rateTypeVal">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in rateTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  不计费时长(分钟)
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <input class="form-control" placeholder maxlength="2" v-model="form.freeDuration" />
                  <!-- <select
                    class="form-control"
                    :disabled="edit==''"
                    v-model="form.freeDuration"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in timeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>-->
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">功率档数</label>
                <div class="col-sm-12">
                  <!-- <input
                    disabled
                    class="form-control"
                    placeholder
                    maxlength="30"
                    :value="powerNum==0?'请在功率设置中进行添加':powerNum"
                  />-->
                  <select class="form-control" v-model="powerNum">
                    <option selected="selected" disabled="disabled" value="0">请选择</option>
                    <option v-for="(item,index) in 9" :key="index" :value="item">{{item}}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="form-group form-group-50">
                <label  class="col-sm-12 control-label">
                  设备类型
                   <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    :disabled="edit!='add'"
                    v-model="form.deviceType"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in deviceTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>-->

              <div class="form-group" v-show="powerNum!=0 && form.rateTypeVal">
                <label class="col-sm-12 control-label">
                  费率详情
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <!-- 双步长功率 -->
                <table
                  v-show="form.rateTypeVal==2 "
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 60px; min-width:60px">档数</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 90px;width: 90px;"
                      >功率(mA)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 125px;width: 125px;"
                      >起步步长(分钟)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 110px;width: 110px;"
                      >起步费率(元)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 170px;width: 170px;"
                      >起步时长包扣除(分钟)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 125px;width: 125px;"
                      >后续步长(分钟)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 110px;width: 110px;"
                      >后续费率(元)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 170px;width: 170px;"
                      >后续时长包扣除(分钟)</th>
                    </tr>
                  </thead>
                  <tbody v-if="powerList.length">
                    <tr v-for="(item, num) in powerList" :key="num+ '-index'">
                      <td class="text-center">{{ num + 1 }}</td>
                      <td class="text-center">{{ item.power }}</td>

                      <td class="text-center">
                        <input
                          type="number"
                          class="form-control col-sm-12"
                          placeholder="元"
                          maxlength="30"
                          v-model="item.FirstStep"
                        />
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          type="number"
                          class="form-control col-sm-12"
                          placeholder="元"
                          maxlength="30"
                          v-model="item.FirstStepRate"
                        />
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        起步时长包扣除
                        <input
                          type="number"
                          class="form-control col-sm-12"
                          placeholder="元"
                          maxlength="30"
                          v-model="item.FirstStepRate"
                        />
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          type="number"
                          class="form-control col-sm-12"
                          placeholder="元"
                          maxlength="30"
                          v-model="item.Step"
                        />
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          type="number"
                          class="form-control col-sm-12"
                          placeholder="元"
                          maxlength="30"
                          v-model="item.StepRate"
                        />
                      </td>

                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        后续时长包扣除
                        <input
                          type="number"
                          class="form-control col-sm-12"
                          placeholder="元"
                          maxlength="30"
                          v-model="item.StepRate"
                        />
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="8">查无数据</td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div
                  v-for="(item,num) in powerList"
                  :key="num+ '-index'"
                  v-show="form.rateTypeVal==2 "
                >
                  <div class="input-group col-sm-12">
                    <span
                      class="input-group-text form-control col-sm-2"
                      style="border-radius:0;"
                    >{{num+1}}档功率</span>
                    <div class="col-sm-10 form-group form-group-b" style="padding-right: 0;">
                      <select
                        class="form-control col-sm-4"
                        style="display:inline-block;"
                        v-model="item.FirstStep"
                      >
                        <option selected="selected" disabled="disabled" value="0">请选择</option>
                        <option
                          v-for="(item,index1) in 24"
                          :key="index1"
                          :value="item * 30"
                        >{{item * 30}}分钟</option>
                      </select>
                      <input
                        type="number"
                        :disabled="edit==''"
                        class="form-control col-sm-7"
                        style="margin-left:28px;display:inline-block;"
                        placeholder="元"
                        maxlength="30"
                        v-model="item.FirstStepRate"
                      />
                    </div>
                  </div>
                  <div class="input-group col-sm-12">
                    <span
                      class="input-group-text form-control col-sm-2 opacity-0"
                      style="border-radius:0;"
                    >{{num+1}}档功率</span>
                    <div class="col-sm-10 form-group form-group-b" style="padding-right: 0;">
                      <select
                        class="form-control col-sm-4"
                        style="display:inline-block;"
                        v-model="item.Step"
                      >
                        <option selected="selected" disabled="disabled" value="0">请选择</option>
                        <option
                          v-for="(item,index1) in 24"
                          :key="index1"
                          :value="item * 30"
                        >{{item * 30}}分钟</option>
                      </select>
                      <input
                        type="number"
                        :disabled="edit==''"
                        class="form-control col-sm-7"
                        style="margin-left:28px;display:inline-block;"
                        placeholder="元"
                        maxlength="30"
                        v-model="item.StepRate"
                      />
                    </div>
                  </div>
                </div>-->

                <!-- 分段功率 -->
                <table
                  v-show="form.rateTypeVal==3 "
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 60px; min-width:60px">档数</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 90px;width: 90px;"
                      >功率(mA)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 125px;width: 125px;"
                      >步长(分钟)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 110px;width: 110px;"
                      >费率(元)</th>
                    </tr>
                  </thead>
                  <tbody v-if="powerList.length">
                    <tr v-for="(item, num) in powerList" :key="num+ '-index'">
                      <td class="text-center">{{ num + 1 }}</td>
                      <td class="text-center">{{ item.power }}</td>
                      <td class="text-center">
                        <input
                          type="number"
                          class="form-control col-sm-12"
                          placeholder="元"
                          maxlength="30"
                          v-model="item.FirstStep"
                        />
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          type="number"
                          class="form-control col-sm-12"
                          placeholder="元"
                          maxlength="30"
                          v-model="item.FirstStepRate"
                        />
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="4">查无数据</td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div v-for="(item,dex) in powerList" :key="dex" v-show="form.rateTypeVal==3">
                  <div class="input-group col-sm-12" v-for="(d, i) in item.DataList" :key="i">
                    <span
                      class="input-group-text form-control col-sm-2"
                      style="border-radius:0;"
                      :class="{'opacity-0':i>0}"
                    >{{dex+1}}档功率</span>
                    <div class="col-sm-10 form-group" style="padding-right: 0;">
                      <select
                        class="form-control col-sm-4"
                        style="display:inline-block;"
                        v-model="d.Step"
                      >
                        <option selected="selected" disabled="disabled" value="0">请选择</option>
                        <option
                          v-for="(item,index2) in 24"
                          :key="index2"
                          :value="item * 30"
                        >{{item * 30}}分钟</option>
                      </select>
                      <input
                        type="number"
                        :disabled="edit==''"
                        class="form-control col-sm-7"
                        style="margin-left:28px;display:inline-block;"
                        placeholder="元"
                        maxlength="30"
                        v-model="d.Rate"
                      />
                    </div>
                  </div>
                  <div class="fu">
                    <div
                      class="btn-group mb-2"
                      role="group"
                      aria-label="Icons Outline File group"
                      v-show="form.rateTypeVal==3"
                    >
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="addPower(dex)"
                      >增加</button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="delPower(dex)"
                      >删除</button>
                    </div>
                  </div>
                </div>-->
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              v-if="edit!=''"
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit()"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 点击档数 -->
    <div
      class="modal fade"
      id="modal-default-normal-list"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-list"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">费率明细</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <div class="block-content block-content-full">
              <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="table-responsive">
                      <!-- 双步长 -->
                      <table
                        v-show="type=='BillingNormal' "
                        class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 60px; min-width:60px">档数</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 90px;width: 90px;"
                            >功率(mA)</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 125px;width: 125px;"
                            >起步步长(分钟)</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 110px;width: 110px;"
                            >起步费率(元)</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 170px;width: 170px;"
                            >起步时长包扣除(分钟)</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 125px;width: 125px;"
                            >后续步长(分钟)</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 110px;width: 110px;"
                            >后续费率(元)</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 170px;width: 170px;"
                            >后续时长包扣除(分钟)</th>
                          </tr>
                        </thead>
                        <tbody v-if="seePowerList.length">
                          <tr v-for="(item, num) in seePowerList" :key="num+ '-index'">
                            <td class="text-center">{{ item.rownum }}档</td>
                            <td class="text-center">{{ item.power }}</td>
                            <td class="text-center">{{item.FirstStep}}</td>
                            <td
                              class="text-center d-xl-table-cell"
                              style="min-width:80px;"
                            >{{item.FirstStepRate}}</td>
                            <td
                              class="text-center d-xl-table-cell"
                              style="min-width:80px;"
                            >{{item.FirstStepMinute }}</td>
                            <td
                              class="text-center d-xl-table-cell"
                              style="min-width:80px;"
                            >{{item.Step }}</td>
                            <td
                              class="text-center d-xl-table-cell"
                              style="min-width:80px;"
                            >{{ item.StepRate }}</td>

                            <td
                              class="text-center d-xl-table-cell"
                              style="min-width:80px;"
                            >{{item.StepMinute }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-center" colspan="8">查无数据</td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- 分段 -->
                      <table
                        v-show="type=='BillingSection' "
                        class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 60px; min-width:60px">档数</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 90px;width: 90px;"
                            >功率(mA)</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 125px;width: 125px;"
                            >步长(分钟)</th>
                            <th
                              class="text-center d-md-table-cell"
                              style="min-width: 110px;width: 110px;"
                            >费率(元)</th>
                          </tr>
                        </thead>
                        <tbody v-if="seePowerList.length">
                          <tr v-for="(item, i) in seePowerList" :key="i">
                            <td class="text-center">{{ item.list }}档</td>
                            <td class="text-center">{{item.power}}</td>
                            <td
                              class="text-center d-xl-table-cell"
                              style="min-width:80px;"
                            >{{item.Step}}</td>
                            <td
                              class="text-center d-xl-table-cell"
                              style="min-width:80px;"
                            >{{item.Rate }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-center" colspan="4">查无数据</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-sm-12 col-md-5" v-show="!isMobile">
                    <div class="dataTables_info" role="status" aria-live="polite">
                      页数
                      <strong>{{ pageModal }}</strong> /
                      <strong>{{ totalPageModal }}</strong>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-7 text-center text-md-right">
                    <div class="dataTables_paginate paging_full_numbers">
                      <el-pagination
                        v-if="walletlList && walletlList.length"
                        @current-change="handleCurrentChangeWallet"
                        :current-page="pageModal"
                        :page-size="10"
                        :small="isMobile"
                        :pager-count="pagerCount"
                        :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                        :total="totalModal"
                        background
                      ></el-pagination>
                    </div>
                  </div>
                </div>-->
              </div>
            </div>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      totalModal: 1,
      pageModal: 1,
      modalData: [],
      clipboard: null,
      sorting: "",
      orderBy: false,
      edit: "",
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      showtips: false,
      powerList: [],
      powerNum: 0,
      num: 0,
      form: {
        cellId: "",
        remark: "",
        rateTypeVal: null,
        freeDuration: "",
        deviceType: ""
      },
      cellName: "",
      deviceTypeList: [
        {
          value: "0",
          label: "默认"
        },
        {
          value: "1",
          label: "NB设备"
        },

        {
          value: "3",
          label: "1拖12"
        },
        {
          value: "2",
          label: "1拖20"
        }
      ],
      timeList: [
        {
          value: 5,
          label: "5分钟"
        },
        {
          value: 10,
          label: "10分钟"
        },
        {
          value: 30,
          label: "30分钟"
        },
        {
          value: 60,
          label: "60分钟"
        }
      ],
      rateTypeList: [
        {
          value: 2,
          label: "双步长"
        },
        {
          value: 3,
          label: "分段"
        }
      ],
      seePowerList: [],
      type: "",
      addBtn: Util.isHavePerm("rateManagement/addRate"),
      editBtn: Util.isHavePerm("rateManagement/updateRate")
    };
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    totalPageModal() {
      if (this.totalModal == 0) {
        return 0;
      } else {
        return Math.ceil(this.totalModal / 10, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    },

    searchKye() {
      return this.$store.state.searchKye;
    },
    params() {
      return this.$store.state.params;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },
    pageSize(val, old) {
      this.pageSize = parseInt(val);
      this.page = 1;
      this.getList();
    },
    powerNum: {
      handler: function(val, oldVal) {
        if (typeof oldVal != "undefined") {
          if (this.form.cellId == "" && this.powerNum != 0) {
            Util.message("war", "请选择小区");
            this.powerNum = oldVal;
          }
        }
        if (typeof this._powerList == "undefined") {
          return;
        }
        if (val > this._powerList.length) {
          Util.message("war", "费率档数不能大于功率档数");
          this.powerNum = oldVal;
          return;
        } else {
          let num = Math.abs(this.powerList.length - val);
          if (num > 0) {
            if (val > oldVal) {
              if (this.form.rateTypeVal == 2) {
                for (let i = 0; i < num; i++) {
                  this.powerList.push({
                    power: this._powerList[this.powerList.length + i],
                    Step: null,
                    FirstStepRate: 0,
                    FirstStep: null,
                    StepRate: 0,
                    PowerType: this.powerList.length + 1
                  });
                }
              } else if (this.form.rateTypeVal == 3) {
                for (let i = 0; i < num; i++) {
                  this.powerList.push({
                    power: this._powerList[this.powerList.length + i],
                    PowerType: this.powerList.length + 1,
                    DataList: [
                      {
                        Rate: 0,
                        Step: null
                      }
                    ]
                  });
                }
              }
            } else {
              for (let i = 0; i < num; i++) {
                this.powerList.pop();
              }
            }
          }
        }
        console.log(this.powerNum);
      },
      immediate: true,
      deep: true
    },
    "form.rateTypeVal": {
      handler: function(val, oldVal) {
        if (typeof oldVal == "null") {
          this.powerNum = 0;
        }
        this.powerList = [];
        if (this.form.rateTypeVal == 2 && this.powerNum) {
          for (let i = 0; i < this.powerNum; i++) {
            this.powerList.push({
              power: this._powerList[this.powerList.length + i],
              Step: null,
              FirstStepRate: 0,
              FirstStep: null,
              StepRate: 0,
              PowerType: this.powerList.length + 1
            });
          }
        } else if (this.form.rateTypeVal == 3 && this.powerNum) {
          for (let i = 0; i < this.powerNum; i++) {
            this.powerList.push({
              power: this._powerList[this.powerList.length + i],
              PowerType: this.powerList.length + 1,
              DataList: [
                {
                  Rate: 0,
                  Step: null
                }
              ]
            });
          }
        }
      }
    },
    "form.freeDuration"(val, oldVal) {
      this.form.freeDuration = Util.inputChangeNoDecimal(val);
    },
    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.params.val) {
      this.key = this.searchKye;
    }
    // this.getEntry()
    this.getListRateBy();
    // this.getList();
    this.copy();
    this.getProvince();
  },
  methods: {
    create(val, id) {
      this.powerNum = 0;
      if (val == "") {
        // 点击档数
        jQuery("#modal-default-normal-list").modal("show");
        this.getSeePowerList(id);
      } else {
        // 新增、编辑
        jQuery("#modal-default-normal").modal("show");
      }
      this.edit = val;
      if (this.edit == "add") {
        this.form = {
          cellId: "",
          remark: "",
          rateTypeVal: "",
          freeDuration: "",
          deviceType: ""
        };
        this.pro = "";
        this.city = "";
        this.dis = "";
        this.powerList = [];
        this._powerList = [];
        this.showtips = false;
      } else {
        // this.getDetail(id);
      }
    },
    getSeePowerList(id) {
      this.$http.get(`${Util.searchURL}/Billing/GetRateDetail/${id}`).then(
        res => {
          if (res.data.code === 200) {
            this.seePowerList = res.data.data.data;
            this.type = res.data.data.type;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getDetail(id) {
      this.$http.get(`${Util.searchURL}/Billing/GetRate/${id}`).then(
        res => {
          if (res.data.code === 200) {
            let d = res.data.data[0];
            this.form = {
              id: d.ID,
              cellId: d.CELL_ID,
              remark: d.REMARK,
              freeDuration: d.FREE_DURATION,
              rateTypeVal:
                d.RATE_TYPE == "BillingNormal"
                  ? 2
                  : d.RATE_TYPE == "BillingSection"
                  ? 3
                  : 1,
              deviceType: d.DeviceType.toString()
            };
            this.cellName = d.CELL_NAME;
            Util.displayAreaCell(
              d.CELL_ID,
              this,
              true,
              this.edit == "" ? true : false
            );
            this.cellSel(d.CELL_ID);
            this._powerList = JSON.parse(d.RATE_DATA);
            this.powerList = JSON.parse(d.RATE_DATA);
            this.powerNum = this.powerList.length;
            this.num = this.powerList.length;
            for (let i in this.powerList) {
              this.powerList[i].power = d.DATA_LIST[i];
            }
            if (d.RATE_TYPE == "BillingNormal") {
              for (let l in this.powerList) {
                this.powerList[l].FirstStepRate = this.powerList[
                  l
                ].FirstStepRate.toString();
                this.powerList[l].StepRate = this.powerList[
                  l
                ].StepRate.toString();
              }
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    getEntry() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/Info/${this.$route.params.id}`)
        .then(result => {
          this.entry = result.data.data;
          this.$store.commit("setParam", {
            entry: this.entry
          });
        });
    },

    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Billing/ListRateBy/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    getListRateBy(code) {
      if (!code) {
        code = this.regionParams.object;
      }
      this.$http
        .get(
          `${Util.searchURL}/Billing/ListRateBy/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${code}`,
          {
            params: {}
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    showStatus(val) {
      switch (val) {
        case 0:
          return "启用";
        case 1:
          return "禁用";
        default:
          return "启用";
      }
    },
    showType(str) {
      switch (str) {
        case "BillingSingleStep":
          return "单步长";
        case "BillingNormal":
          return "双步长";
        case "BillingSection":
          return "分段步长";
      }
    },
    showDeviceType(str) {
      switch (str) {
        case 0:
          return "默认";
        case 1:
          return "NB设备";
        case 2:
          return "1拖20";
        case 3:
          return "1拖12";
        case 5:
          return "高功率设备";
        case 6:
          return "投币设备";
        case 8:
          return "模块化充电桩";
      }
    },
    search() {
      this.page = 1;
      this.getList();
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtnCharge");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      this.$http
        .get(
          `${Util.searchURL}/Billing/ListRateBy/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListAll`).then(
        res => {
          if (res.data.code === 200) {
            this.fourth = res.data.data;
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${this.pro}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
            this.city = "";
            this.districtList = [];
            this.dis = "";
            this.cellList = [];
            this.form.cellId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      this.$http.get(`${Util.searchURL}/District/ListByCity/${this.city}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
            this.dis = "";
            this.cellList = [];
            this.form.cellId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
              this.form.cellId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    cellSel(val) {
      this.showtips = false;
      this.$http
        .get(`${Util.searchURL}/Power/GetByCell/${this.form.cellId}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this._powerList = res.data.data;
              this.powerNum = this._powerList.length;
              this.showtips = true;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    addPower(i) {
      if (this.form.rateTypeVal == 3) {
        if (this.powerList[i].DataList.length > 10) {
          Util.message("war", "达到分段费率个数添加上线");
          return;
        }
        this.powerList[i].DataList.push({
          Rate: 0,
          Step: null
        });
      } else if (this.form.rateTypeVal == 2) {
        if (this.powerList.length >= this._powerList.length) {
          Util.message(
            "war",
            `该功率档数少于${this._powerList.length + 1}档，无法添加第${this
              ._powerList.length + 1}档功率`
          );
          return;
        } else {
          this.powerList.push({
            Step: null,
            FirstStepRate: 0,
            FirstStep: null,
            StepRate: 0,
            PowerType: this.powerList.length
          });
        }
      }
    },
    delPower(i) {
      if (this.form.rateTypeVal == 3) {
        if (this.powerList[i].DataList.length == 1) {
          Util.message("war", "不能删除");
          return;
        }
        this.powerList[i].DataList.pop();
      } else if (this.form.rateTypeVal == 2) {
        if (this.powerList.length == 1) {
          Util.message("war", "不能删除");
          return;
        } else {
          this.powerList.pop();
        }
      }
    },
    submit() {
      let url = "";
      if (this.edit == "add") {
        url = `${Util.operateURL}/rateManagement/addRate`;
      } else {
        url = `${Util.operateURL}/rateManagement/updateRate`;
      }
      this.form.rateData = this.powerList;
      // console.log(this.form)
      // return
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal").modal("hide");
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  }
};
</script>
<style lang="less">
.fu {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  padding-right: 15px;
}
</style>